export default __webpack_public_path__ + "af2d7de58cdf195f831ec8bd00d9833d.png";